module.exports = __webpack_public_path__ + "../resources/img/module_data_test.4225d44b.svg";